<div class="d-flex gx-2 mt-2">
    @if(recurrence && recurrence.type !== 'once'){
        <div class="text-secondary pe-1">
            <i class="fa-regular fa-arrows-repeat fa-2x"></i>
        </div>
        <div class="">
            <div class="comments px-3">
                @switch (recurrence.type){
                    @case ('weekly'){
                        {{'poll_creation.recurrence_preview.weekly' | translate: {'value': recurrence.value | translate} }}
                    }
                    @case ('monthly'){
                        {{'poll_creation.recurrence_preview.monthly' | translate: {'value': recurrence.value } }}
                    }
                }
            </div>
        </div>
    }
</div>  

